// extracted by mini-css-extract-plugin
export var fileExt = "_v5-8";
export var fileIcon = "_v5-6";
export var fileLink = "_v5-5";
export var fileName = "_v5-7";
export var image = "_v5-1";
export var imageError = "_v5-3";
export var imageErrorIcon = "_v5-4";
export var imageLink = "_v5-0";
export var imageLoaded = "_v5-2";